export default "__VITE_ASSET__DePN2dxY__"